var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { LiveScoreboard, BaseballLiveTableHeader, BaseballAnimation, BaseballLiveTableBody, PlaygroundWrapper } from "../../components";
export class BaseballLiveScoreboardAnimateMobile extends React.PureComponent {
    render() {
        const _a = this.props, { header, title, headerTitles, base, hasHits } = _a, tableBodyProps = __rest(_a, ["header", "title", "headerTitles", "base", "hasHits"]);
        const playGroundHeader = [title];
        return (React.createElement(BaseballAnimation, null,
            React.createElement(LiveScoreboard, null,
                React.createElement(BaseballLiveTableHeader, { header: header, headerTitles: playGroundHeader, hasHits: hasHits }),
                React.createElement(BaseballLiveTableBody, Object.assign({}, Object.assign(Object.assign({}, tableBodyProps), { hasHits })))),
            React.createElement(PlaygroundWrapper, { header: headerTitles, base: base })));
    }
}
//# sourceMappingURL=BaseballLiveScoreboardAnimateMobile.js.map